import { useMemo } from 'react';

import { SectionScheme, Widget } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';

export const usePageRightMenu = () => {
  const {
    state: { widgets, sections, sectionsVisible },
  } = usePageContext();

  const sectionsPageRightMenu = useMemo<SectionScheme[]>(
    () => sections.filter((section, key) => section.textId && sectionsVisible.includes(key)),
    [sectionsVisible],
  );
  const widgetsPageRightMenu = useMemo<Widget[]>(() => widgets.filter((w) => !w.hidden), [widgets]);

  const showPageRightMenu: boolean =
    (widgetsPageRightMenu.length > 0 && widgetsPageRightMenu.every((widget) => widget.notShownInRightMenu !== true)) ||
    sectionsPageRightMenu.length > 1;

  return { showPageRightMenu, sectionsPageRightMenu };
};
